import { makeStyles } from 'tss-react/mui';

import { IStyleProps } from '../interfaces';

const useStyles = makeStyles<IStyleProps | undefined>()((theme, styles) => ({
  iconButton: {
    width: styles?.width || theme.spacing(3.5),
    minWidth: styles?.width || theme.spacing(3.5),
    height: styles?.height || theme.spacing(3.5),
    borderRadius: styles?.borderRadius || '10px', //styles?.borderRadius || '50%',
    backgroundColor: styles?.backgroundColor || '',
    color: styles?.color || theme.palette.font.secondary,
    padding: styles?.padding || 'initial',
    '&:hover': {
      ...styles?.['&:hover'],
      backgroundColor: theme.palette.background.default,
      // '& [fill]': {
      //   fill: styles?.color || theme.palette.font.secondary,
      // },
      // '& [stroke]': {
      //   stroke: styles?.color || theme.palette.font.secondary,
      // },
    },

    '& svg': {
      width: `calc( ${styles?.width || theme.spacing(4)} * 0.6)`,
      height: `calc( ${styles?.height || theme.spacing(4)} * 0.6)`,
      color: styles?.color || theme.palette.font.secondary,
    },
  },
  iconActiveButton: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    '& [fill]': {
      fill: theme.palette.background.default,
    },
  },
  disabledButton: {
    '&:disabled': {
      color: theme.palette.grey[300],
      ...styles?.['&:disabled'],
    },
    '& [fill]': {
      fill: theme.palette.background.default,
    },
  },
}));
export default useStyles;
